import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-terms-and-conditions-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Terms and Conditions</span>
      <div articleBody>
        <div class="iframe-container">
          <iframe class="iframe-content" src="https://www.iubenda.com/terms-and-conditions/85763951"></iframe>
        </div>
      </div>
    </app-policy-article>
  `
})
export class TermsAndConditionsArticleComponent {

}
